
import React from 'react';
import { BookingStatus } from '../types';

interface StatusBadgeProps {
  status: BookingStatus;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config: Record<BookingStatus, { label: string; style: string }> = {
    PENDING: { label: '待審核', style: 'bg-amber-100 text-amber-700 border-amber-200' },
    CONFIRMED: { label: '已確認', style: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
    REJECTED: { label: '已拒絕', style: 'bg-rose-100 text-rose-700 border-rose-200' },
    COMPLETED: { label: '已完成', style: 'bg-slate-100 text-slate-700 border-slate-200' },
  };

  const { label, style } = config[status] || { label: status, style: 'bg-slate-100 text-slate-700' };

  return (
    <span className={`px-2 py-0.5 rounded text-xs font-semibold border ${style}`}>
      {label}
    </span>
  );
};
